<template>
  <v-container fluid>
    <v-layout
      v-if="groupsLoading"
      align-space-around
      justify-space-around
      column
      fill-height
    >
      <v-flex>
        <v-progress-circular
          :size="50"
          color="secondary"
          indeterminate
        />
      </v-flex>
    </v-layout>
    <v-layout
      v-else
      align-space-around
      justify-space-around
      column
      fill-height
    >
      <div v-if="hasGroups">
        <v-flex>
          <h1>{{ strings.awaitingRepair }}</h1>
        </v-flex>
        <v-flex
          v-for="group in groups"
          :key="group.id"
        >
          <v-list>
            <v-list-group
              prepend-icon="mdi-view-dashboard"
              value="false"
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-title>{{ group.name }}</v-list-tile-title>
                </v-list-tile>
              </template>
              <v-list-tile
                v-for="(poi, index) in group.pois"
                :key="index"
              >
                <v-flex>
                  {{ poi.name }}
                  <v-btn
                    class="float-right"
                    color="primary"
                    @click="poiClicked(poi)"
                  >
                    <v-icon color="text">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </v-flex>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </v-flex>
      </div>
      <div v-else>
        <v-flex>
          <h3>{{ strings.noPointsofInteresttoshow }}</h3>
        </v-flex>
      </div>
    </v-layout>
    <repair-poi
      v-if="selectedPoi"
      v-model="showRepair"
      :poi="selectedPoi"
      @close="showRepair=false"
    />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import RepairPoi from "../components/RepairPoi.vue";
export default {
  components: { RepairPoi },
  data() {
    return {
      selectedPoi: null,
      showRepair: false
    }
  },
  computed: {
    ...mapGetters("page", ["strings"]),
    ...mapGetters("group", ["groupsLoading", "repairGroups"]),
    groups() {
      return this.repairGroups.filter(l => l.pois.length > 0);
    },
    hasGroups() {
      return this.groups.length > 0;
    }
  },
  methods: {
    poiClicked(poi) {
      this.selectedPoi = poi;
      this.showRepair = true;
    }
  }
}
</script>

<style scoped>

</style>